/**
 * Domain icon URLs from Riftbound assets (see .tmp/bin/Icons.html).
 * Official Riot CDN URLs for domain icons — Body, Calm, Chaos, Fury, Mind, Order.
 * Colourless has no icon in the asset list.
 */
const BASE = 'https://cmsassets.rgpub.io/sanity/images/dsfx7636/game_data_live';
const Q = '?accountingTag=RB';

export const DOMAIN_ICON_URLS = {
  body: `${BASE}/7a5533034de5870808347bc4b296f0029bdd8eea-64x64.png${Q}`,
  calm: `${BASE}/b9ef2f5b74841ad11f3629aa381a76ac0187d007-64x64.png${Q}`,
  chaos: `${BASE}/597ddb82be59e87b467c52bb10204f02c2005d06-64x64.png${Q}`,
  fury: `${BASE}/5aeb4bfd203b5d265902f65aa5afae7da1682eaa-64x64.png${Q}`,
  mind: `${BASE}/17ab95a6bd052085b6803d846a287f625f347288-64x64.png${Q}`,
  order: `${BASE}/8bb1b193a8e1adc26ca28e1a21da8d1e2f5d2f72-64x64.png${Q}`,
  colourless: null,
  colorless: null
};

export function getDomainIconUrl(domainId) {
  return DOMAIN_ICON_URLS[domainId] ?? DOMAIN_ICON_URLS.colourless ?? null;
}
